import SignUtils, { AppSignUtils } from './sign';
import { tokenStorage, userStorage } from './storage'
import { deviceStorage } from './storage'
import { appStorage } from './storage'

  // 设置请求配置
  export const setConfig = (config: any) => {
    // 从 localStorage 中读取 token
    const token = tokenStorage.getToken();
    // 🔧 修复：每次请求时重新生成签名，避免时间戳过期导致 403
    const sign = SignUtils.generateApiSignature(
      token || '', 
      userStorage.getTouristInfo()?.userId || '', 
      AppSignUtils.APP_SECRET || ''
    )

    // 如果存在 token，添加到请求头
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // 添加语言标识到请求头，支持国际化
    const locale = localStorage.getItem("nuxt-i18n-locale") || "en";
    config.headers["Accept-Language"] = locale;

    // 自动添加 udid 和 appId 到请求参数
    const udid = deviceStorage.getUdid();
    const appId = appStorage.getAppId();

    if (udid && appId) {
      // 如果是 GET 请求，添加到 URL 参数
      if (config.method === "get" && config.params) {
        config.params.udid = udid;
        config.params.appId = appId;
        config.params.sign = sign;
      } else if (config.method === "get") {
        config.params = { udid, appId, sign };
      }

      // 如果是 POST/PUT/PATCH 请求，添加到请求体
      if (
        ["post", "put", "patch"].includes(config.method || "") &&
        config.data
      ) {
        if (typeof config.data === "object") {
          config.data.udid = udid;
          config.data.appId = appId;
          config.data.sign = sign;
        }
      } else if (["post", "put", "patch"].includes(config.method || "")) {
        config.data = { udid, appId, sign };
      }
    }
  }